import SourceManager from '../components/SourceManager.jsx';

export default function AdminSourcesSection() {
  return <SourceManager apiBase="/sources" showLastError />;
}
